module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui modal"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('form', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v("Subject")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.subject),
      expression: "task.subject"
    }],
    attrs: {
      "type": "text",
      "name": "subject"
    },
    domProps: {
      "value": (_vm.task.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "subject", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.description),
      expression: "task.description"
    }],
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.task.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('div', {
    staticClass: "seven wide required field"
  }, [_c('label', [_vm._v("Owner")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.owner),
      expression: "task.owner"
    }],
    staticClass: "ui fluid search dropdown",
    attrs: {
      "name": "owner"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "owner", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.owners), function(ow) {
    return _c('option', {
      domProps: {
        "value": ow.id
      }
    }, [_vm._v(_vm._s(ow.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v("Due Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.dueDate),
      expression: "task.dueDate"
    }],
    attrs: {
      "id": "taskDueDate",
      "name": "dueDate",
      "type": "text",
      "data-toggle": "datepicker"
    },
    domProps: {
      "value": (_vm.task.dueDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "dueDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.status),
      expression: "task.status"
    }],
    staticClass: "ui fluid search dropdown",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "backlog"
    }
  }, [_vm._v("Backlog")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "doing"
    }
  }, [_vm._v("Doing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "blocked"
    }
  }, [_vm._v("Blocked")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "done"
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "archived"
    }
  }, [_vm._v("Archived")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, _vm._l((_vm._tags), function(tag) {
    return _c('div', {
      class: _vm.getTagClass(tag)
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.formattedTag(tag)) + "\n\t\t\t\t\t"), _c('i', {
      staticClass: "close icon",
      on: {
        "click": function($event) {
          return _vm.deleteTag(tag)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [(_vm.newTag) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui mini input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "newTag"
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveNewTag($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancelNewTag($event)
      }]
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newTag) ? _c('div', {
    staticClass: "field"
  }, [_c('chrome-picker', {
    ref: "colorpicker",
    attrs: {
      "palette": _vm.palette
    },
    model: {
      value: (_vm.colors),
      callback: function($$v) {
        _vm.colors = $$v
      },
      expression: "colors"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.newTag) ? _c('a', {
    staticClass: "ui left pointing basic label",
    on: {
      "click": _vm.addNewTag
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" New tag\n\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.saveTask()
      }
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ca25f28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taskDialog.vue
// module id = 247
// module chunks = 1